import { Col } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $Heading = styled.div`
  font-weight: 800;
  font-size: ${({ theme }) => theme.tw.font.size['2xl']};
  line-height: 28px;
  color: ${({ theme }) => theme.systemColors.defaultTextColor};
  margin-bottom: ${spacing(12)};
`;

export const $CardContainer = styled.div`
  margin-top: ${spacing('xxl')};
`;

export const $Col = styled(Col)`
  margin-top: ${spacing('xxl')};
`;
